export default () => ({
  input: undefined,
  len: 0,
  init() {
    mrp.log(`RxInputTextArea init`);
    this.input = this.$refs.input;
    this.setLen();
  },
  setLen() {
    mrp.log("RxInputTextArea setLen");
    if (this.input?.value) {
      this.len = this.input.value.length;
    } else {
      this.len = 0;
    }
  },
  deferSetLen() {
    mrp.log("RxInputTextArea deferSetLen");
    this.$nextTick(() => {
      this.setLen();
    });
  },
});
